import { SortOptionType } from "Components/SortBar";
import { FormObjType } from "DataTypes/Form";

export const MedsForm: FormObjType[] = [
  {
    id: "productName",
    label: "Product Name",
    placeholder: "Enter Product Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeholder: "Select Start Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
    // notValidateMinMax: true,
    dateType: "start"
  },
  {
    id: "endDate",
    label: "Stop Date",
    placeholder: "Select End Date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    required: false,
    enableFormLoad: true,
    // notValidateMinMax: true,
    dateType: "stop"
  },
  {
    id: "doseQuantity",
    label: "Dose Quantity",
    placeholder: "Enter Dose Quantity",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "doseUnits",
    label: "Dose Units",
    placeholder: "Enter Dose Units",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "frequencyPeriod",
    label: "Frequency",
    placeholder: "Enter Frequency",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "frequencyUnit",
    label: "Frequency Unit",
    placeholder: "Enter Frequency Unit",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "routeName",
    label: "Route Name",
    placeholder: "Enter Route Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
]

// The values are the search API's own sortBy values.
export const sortOptions: SortOptionType[] = [
  { label: "Name", value: "name" },
  { label: "Date", value: "date" },
];
